/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SuppressTimeRegOutsideProjectPeriodWarningInput = {|
  projectId: string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type suppressTimeRegOutsideProjectPeriodWarningMutationVariables = {|
  input: SuppressTimeRegOutsideProjectPeriodWarningInput
|};
export type suppressTimeRegOutsideProjectPeriodWarningMutationResponse = {|
  +suppressTimeRegOutsideProjectPeriodWarning: ?{|
    +clientMutationId: ?string
  |}
|};
export type suppressTimeRegOutsideProjectPeriodWarningMutation = {|
  variables: suppressTimeRegOutsideProjectPeriodWarningMutationVariables,
  response: suppressTimeRegOutsideProjectPeriodWarningMutationResponse,
|};
*/


/*
mutation suppressTimeRegOutsideProjectPeriodWarningMutation(
  $input: SuppressTimeRegOutsideProjectPeriodWarningInput!
) {
  suppressTimeRegOutsideProjectPeriodWarning(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SuppressTimeRegOutsideProjectPeriodWarningInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressTimeRegOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressTimeRegOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "suppressTimeRegOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressTimeRegOutsideProjectPeriodWarningMutation(\n  $input: SuppressTimeRegOutsideProjectPeriodWarningInput!\n) {\n  suppressTimeRegOutsideProjectPeriodWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1bdb276993b1a24d6c34f5927ea00c16';

module.exports = node;
